import React from "react"
import { uid } from "react-uid"
import { withTheme } from "emotion-theming"

import toDuration from "@utils/toDuration"

import { BarWrapper, BarTime, BarProgress, BarKnob } from "./styles"

const Bar = ({ theme, duration, curTime, onTimeUpdate }) => {
  const curPercentage = (curTime / duration) * 100
  const progressBar = uid("progress-bar")

  const calcClickedTime = e => {
    const clickPositionInPage = e.pageX
    const bar = document.getElementById(progressBar)
    const barStart = bar.getBoundingClientRect().left + window.scrollX
    const barWidth = bar.offsetWidth
    const clickPositionInBar = clickPositionInPage - barStart
    const timePerPixel = duration / barWidth
    return timePerPixel * clickPositionInBar
  }

  const handleTimeDrag = e => {
    onTimeUpdate(calcClickedTime(e))

    const updateTimeOnMove = eMove => {
      onTimeUpdate(calcClickedTime(eMove))
    }

    document.addEventListener("mousemove", updateTimeOnMove)

    document.addEventListener("mouseup", () => {
      document.removeEventListener("mousemove", updateTimeOnMove)
    })
  }

  return (
    <BarWrapper>
      <BarTime>{toDuration(curTime)}</BarTime>
      <BarProgress
        id={progressBar}
        onMouseDown={e => handleTimeDrag(e)}
        style={{
          background: `linear-gradient(to right, ${
            theme.colours.secondary
          } ${Math.floor(curPercentage)}%, white 0`,
        }}
      >
        <BarKnob
          style={{
            left: `${Math.floor(curPercentage) - 2}%`,
          }}
        />
      </BarProgress>
      <BarTime>{toDuration(duration)}</BarTime>
    </BarWrapper>
  )
}

export default withTheme(Bar)
